import React, { useState } from "react";
import SeoHelmet from "@/components/SeoHelmet";
import seoConfig from "@/data/seo.config";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";

import isEmpty from "lodash/isEmpty";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { forgotPasswordAction } from "@/actions/loginAction";
//import "../Orex.css";

import errorMessages from "@/constant/errorMessages";
import regExp from "@/constant/regExpressions";
import { publicRoutePaths } from "@/routes/public.routes.config";
import { showSuccessMessage } from "@/utils/common";
import Button from "@/components/Button";
import ConsentManager from "@/modules/frontend/components/ConsentManager";

import loginThumb from "@/assets/images/webp/login-thumb-bg.webp";


const Index = (props) => {
  const nav = useNavigate("");
  const [errors, setErrors] = useState({});
  const [email, setEmail] = useState();

  var [isButtonDisabled, setisButtonDisabled] = useState(false);

  const emailPattern = regExp.email;

  const handleSubmit = async (e) => {
    e.preventDefault();
    // setisButtonDisabled(true);
    if (!validation()) {
      setisButtonDisabled(true);
      await props
        .forgotPassword(email)
        .then((response) => {
          setisButtonDisabled(false);
          if (response.message === "We have emailed your password reset link!") {
            showSuccessMessage("We have emailed your password reset link!");
          } else {
            const errors = {};
            if (response.status === false) {
              if (response.message === "Validation Error.") {
                if (!isEmpty(response.error.email)) {
                  errors.email = response.error.email[0];
                }
              }
              if (response.message === "The email is not registered.") {
                errors.email = response.error.email[0];
              }
              if (!response) {
                errors.somethingWentWrong = "Something went wrong";
              }
            }
            setErrors(errors);
          }
        })
        .catch((error) => {
          setisButtonDisabled(false);
          console.log(error);
        });
    }
  };

  const handleKeyDown = (e) => {
    // console.log(e.code);
    if (e.code === "Space") {
      e.preventDefault();
    }
  };

  const validation = () => {
    const errors = {};
    if (email === "" || email === null) {
      errors.email = errorMessages.FIELD_REQUIRED;
    } else if (emailPattern.test(email) === false) {
      errors.email = errorMessages.INVALID_EMAIL;
    }

    setErrors(errors);
    return Object.keys(errors).length > 0;
  };

  const styleError = {
    display: "block",
  };

  const handleFocusOut = async (e) => {
    const verrors = { ...errors };
    if (e.target.name === "email") {
      if (e.target.value === "" || e.target.value === null) {
        verrors.email = errorMessages.FIELD_REQUIRED;
      } else if (emailPattern.test(e.target.value) === false) {
        verrors.email = errorMessages.INVALID_EMAIL;
      } else {
        verrors.email = "";
      }
    }
    setErrors(verrors);
    return Object.keys(verrors).length > 0;
  };

  return (
    <section className="registration-wrape login-page-wrape">
       <SeoHelmet
          title={seoConfig.forgotPassword.title}
          description={seoConfig.forgotPassword.description}
          keywords={seoConfig.forgotPassword.keywords}
          author={seoConfig.forgotPassword.author}
        />
      <div className="container">
        <div className="row">
          <div className="col-xxl-7 col-xl-6 col-lg-5 col-md-3 col-sm-12 "></div>
          <div className="col-xxl-5 col-xl-6 col-lg-7 col-md-9 col-sm-12 ">
            <div className="form-pad">
              <div className="section-head">
                <div className="head">
                  <h2 className="">
                    Forgot Password
                  </h2>
                  <p className="text">
                    Enter your email and we'll send you instructions to reset your
                    password.
                  </p>
                  <img src={loginThumb} alt="Aero Plane" className="head-thumb" />
                </div>
              </div>

              <form id="account-detail" className="custom-form">
                <div className="row">
                  <div className="col-xxl-12">
                    {/* {errors.somethingWentWrong && (
                    <div className="invalid-feedback" style={styleError}>
                      {errors.somethingWentWrong}
                    </div>
                  )} */}
                    <div className={`input-wrape ${errors.email ? 'error-show' : ''}`}>

                      {errors.somethingWentWrong && (
                        <div className="invalid-feedback" style={styleError}>
                          {errors.somethingWentWrong}
                        </div>
                      )}

                      <div className="input-pad">
                        <input
                          type="email"
                          id="contact-form-email"
                          className="input"
                          autoComplete="off"
                          placeholder="Enter your email*"
                          onChange={(e) => setEmail(e.target.value)}
                          onBlur={handleFocusOut}
                          onKeyDown={handleKeyDown}
                          name="email"
                          value={email}
                        />
                        {errors.email && (
                          <div className="invalid-feedback" style={styleError}>
                            {errors.email}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
                    {/* <button
                    type="button"
                    className="btn border-btn"
                    onClick={() => {
                      nav(publicRoutePaths.LOGIN.path);
                    }}
                  >
                    <i className="fa-solid fa-angle-left mx-1"></i>
                    Back to login
                  </button> */}
                    {/* <span
                      className="login-text back-btn"
                    >
                      <span 
                        onClick={() => nav(publicRoutePaths.LOGIN.path)}>
                        <img src={backArrow} alt="" />
                        Back to Login
                      </span>
                    </span> */}
                  </div>
                  <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 inquiry-form-btn">
                    {/* <div className="btn-wrape">
                    <button
                      type="submit"
                      className="btn secondry-btn"
                      onClick={handleSubmit}
                      disabled={isButtonDisabled}
                    >
                      Send Reset Link
                    </button>
                  </div> */}
                    <Button
                      className="btn outline"
                      type="button"
                      onClick={() => nav(publicRoutePaths.LOGIN.path)}
                    >
                      Back to Login
                    </Button>
                    <Button
                      className="btn secondry-btn"
                      type="submit"
                      onClick={handleSubmit}
                      disabled={isButtonDisabled}
                    >
                      Send Reset Link
                    </Button>
                  </div>
                </div>
              </form>



              {/* <footer className="white-bg full">
        <div className="footer-bottom">
          <span className="copy-right">
            Copyright © 2025 All Rights Reserved by OREX TRADE WORLD INC
          </span>

          <span className="signature">
            Design & Developed By{" "}
            <Link
              className="footer-design"
              to="https://infinglobal.com/"
              target="_blank"
            >
              {" "}
              InfinGlobal
            </Link>
          </span>
        </div>
      </footer> */}
            </div>
          </div>
        </div>
      </div>
      <ToastContainer></ToastContainer>
      <ConsentManager data={""} />
    </section>
  );
}
const mapStateToProps = (state) => {
  return {
    auth: state.auth.login,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    forgotPassword: (email) => dispatch(forgotPasswordAction(email)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Index);
